<template>
    <div class="go-in">
       <template v-if="width >= 1200">
         <!-- banner -->
         <div class="banner">
           <el-carousel  trigger="click" height="640px" style="position:relative;">
             <el-carousel-item v-for="item in heartScienceList" :key="item">
               <!-- <div class="big"> -->
               <div class="box">
                 <div style="width:1440px;margin:0 auto">
                   <div class="title">{{ item.title }}</div>
                   <div class="eng">{{ item.titleEn }}</div>
                 </div>
               </div>
               <img :src="imgserver + item.picture" alt="">
               <!-- </div> -->
             </el-carousel-item>
           </el-carousel>
         </div>
         <div class="banner">
           <el-carousel  trigger="click" height="640px">
             <el-carousel-item v-for="item in heartDrillList" :key="item">
               <div class="big">
                 <div class="box">
                   <div style="width:1440px;margin:0 auto">
                     <div class="title">{{ item.title }}</div>
                     <div class="eng">{{ item.titleEn }}</div>
                   </div>
                 </div>
                 <!-- <div style="width:50%;height:90%;padding-top:30px"> -->
                 <img :src="imgserver + item.picture" alt="">
                 <!-- </div> -->
               </div>
             </el-carousel-item>
           </el-carousel>
         </div>
         <div class="banner">
           <el-carousel  trigger="click" height="640px">
             <el-carousel-item v-for="item in specialtyWorkList" :key="item">
               <div class="big">
                 <div class="box">
                   <div style="width:1440px;margin:0 auto">
                     <div class="title">{{ item.title }}</div>
                     <div class="eng">{{ item.titleEn }}</div>
                   </div>
                 </div>
                 <!-- <div style="width:50%;height:90%;padding-top:30px"> -->
                 <img :src="imgserver + item.picture" alt="">
                 <!-- </div> -->
               </div>
             </el-carousel-item>
           </el-carousel>
         </div>
         <div class="banner">
           <el-carousel  trigger="click" height="640px">
             <el-carousel-item v-for="item in universityPsychologyList" :key="item">
               <div class="big">
                 <div class="box">
                   <div style="width:1440px;margin:0 auto">
                     <div class="title">{{ item.title }}</div>
                     <div class="eng">{{ item.titleEn }}</div>
                   </div>
                 </div>
                 <!-- <div style="width:50%;height:90%;padding-top:30px"> -->
                 <img :src="imgserver + item.picture" alt="">
                 <!-- </div> -->
               </div>
             </el-carousel-item>
           </el-carousel>
         </div>
       </template>
      <template v-if="width <= 768">
        <!-- banner -->
        <div class="banner">
          <el-carousel  trigger="click" height="160px" style="position:relative;">
            <el-carousel-item v-for="item in heartScienceList" :key="item">
              <!-- <div class="big"> -->
              <div class="box">
                <div style="width:100%;margin:0 auto">
                  <div class="title">{{ item.title }}</div>
                  <div class="eng">{{ item.titleEn }}</div>
                </div>
              </div>
              <img :src="imgserver + item.picture" alt="">
              <!-- </div> -->
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="banner">
          <el-carousel  trigger="click" height="160px">
            <el-carousel-item v-for="item in heartDrillList" :key="item">
              <div class="big">
                <div class="box">
                  <div style="width:100%;margin:0 auto">
                    <div class="title">{{ item.title }}</div>
                    <div class="eng">{{ item.titleEn }}</div>
                  </div>
                </div>
                <!-- <div style="width:50%;height:90%;padding-top:30px"> -->
                <img :src="imgserver + item.picture" alt="">
                <!-- </div> -->
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="banner">
          <el-carousel  trigger="click" height="160px">
            <el-carousel-item v-for="item in specialtyWorkList" :key="item">
              <div class="big">
                <div class="box">
                  <div style="width:100%;margin:0 auto">
                    <div class="title">{{ item.title }}</div>
                    <div class="eng">{{ item.titleEn }}</div>
                  </div>
                </div>
                <!-- <div style="width:50%;height:90%;padding-top:30px"> -->
                <img :src="imgserver + item.picture" alt="">
                <!-- </div> -->
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="banner">
          <el-carousel  trigger="click" height="160px">
            <el-carousel-item v-for="item in universityPsychologyList" :key="item">
              <div class="big">
                <div class="box">
                  <div style="width:100%;margin:0 auto">
                    <div class="title">{{ item.title }}</div>
                    <div class="eng">{{ item.titleEn }}</div>
                  </div>
                </div>
                <!-- <div style="width:50%;height:90%;padding-top:30px"> -->
                <img :src="imgserver + item.picture" alt="">
                <!-- </div> -->
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </template>
    </div>
</template>

<script>
import { getequip } from "../api/api";
export default {
    data () {
        return {
            heartScienceList:[],//心理科普装备
            heartDrillList:[],//心理训练
            specialtyWorkList:[],//专业工作
            universityPsychologyList:[],//专业工作
          width:document.body.clientWidth,

        }
    },
    mounted () {
        let that = this
      window.addEventListener("resize", function (e) {
        that.width = e.target.document.documentElement.clientWidth
      });
         //心理装备
         getequip().then(res => {
                this.heartScienceList = res.data.data.heartScienceList
                this.heartDrillList = res.data.data.heartDrillList
                this.specialtyWorkList = res.data.data.specialtyWorkList
                this.universityPsychologyList = res.data.data.universityPsychologyList
            })
    }

}
</script>

<style lang="scss" scoped>
    * {
        margin: 0;
        padding: 0;
    }
    .go-in {
        width: 100%;
        height: 100%;
    }
    ::v-deep .el-tabs__item{
        color: #666666 !important;
    }
    .banner{
        width: 100%;
        height: 640px;
        // height: 80vh;
    }
    img{
        width: 100%;
        height: 640px;
        background-size: 100% 100%;
    }
    ::v-deep .el-carousel__button{
        width: 65px;
        height: 15px;
        border-radius: 35px;
        background: rgba(216, 216, 216, 0.55);
    }
   ::v-deep .el-carousel__indicator.is-active button{
        background-color: #fff;
    }
    ::v-deep .el-carousel__item {
        // background: linear-gradient(180deg, #EAEAEA 0%, rgba(234, 234, 234, 0) 100%);
        // padding: 0 150px;
        box-sizing: border-box;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
    }
    ::v-deep .el-carousel__indicators--horizontal {
        z-index: 1000;
        bottom: 8%;
    }
    ::v-deep .el-carousel--horizontal{
        list-style:none;
    }
    ::v-deep .el-carousel__container{
        // height: 80vh;
    }
    .one{
        width: 100%;
        // height: 80vh;
        // padding: 50px 0;
        box-sizing: border-box;
        background: linear-gradient(180deg, #EAEAEA 0%, rgba(234, 234, 234, 0) 100%);
    }
    .big{
        // width: 1440px;
        // margin: 0 auto;
        // height: 100%;
        // display: flex;
        // justify-content: space-between;
        // justify-content: flex-end;
    }
    .box{
        width: 100%;
        // margin: 0 auto;
        position: absolute;
        top: 45%;
    //    margin-left: 100px;
        color: #fff;
        font-size: 100px;
    }
    .title{
        font-size: 64px;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0em;
        color: #3D3D3D;
    }
    .eng{
        margin-top: 20px;
        font-size: 30px;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        letter-spacing: 0em;
        color: #3D3D3D;
    }


    @media (max-width: 768px) {
      * {
        margin: 0;
        padding: 0;
      }
      .go-in {
        width: 100%;
        height: 100%;
      }
      ::v-deep .el-tabs__item{
        color: #666666 !important;
      }
      .banner{
        width: 100%;
        height: 160px;
        // height: 80vh;
      }
      img{
        width: 100%;
        height: 160px;
        background-size: 100% 100%;
      }
      ::v-deep .el-carousel__button{
        width: 15px;
        height: 8px;
        border-radius: 35px;
        background: rgba(216, 216, 216, 0.55);
      }
      ::v-deep .el-carousel__indicator.is-active button{
        background-color: #fff;
      }
      ::v-deep .el-carousel__item {
        // background: linear-gradient(180deg, #EAEAEA 0%, rgba(234, 234, 234, 0) 100%);
        // padding: 0 150px;
        box-sizing: border-box;
        // display: flex;
        // flex-direction: column;
        // justify-content: center;
      }
      ::v-deep .el-carousel__indicators--horizontal {
        bottom: 2%;
        width: 100%;
        text-align: center;
        z-index: 1000;
      }
      ::v-deep .el-carousel--horizontal{
        list-style:none;
      }
      ::v-deep .el-carousel__container{
        // height: 80vh;
      }
      .one{
        width: 100%;
        // height: 80vh;
        // padding: 50px 0;
        box-sizing: border-box;
        background: linear-gradient(180deg, #EAEAEA 0%, rgba(234, 234, 234, 0) 100%);
      }
      .big{
        // width: 1440px;
        // margin: 0 auto;
        // height: 100%;
        // display: flex;
        // justify-content: space-between;
        // justify-content: flex-end;
      }
      .box{
        width: 100%;
        // margin: 0 auto;
        position: absolute;
        top: 45%;
        //    margin-left: 100px;
        color: #fff;
        font-size: 100px;
      }
      .title{
        font-size: 14px;
        font-weight: 700;
        line-height: normal;
        letter-spacing: 0em;
        color: #3D3D3D;
      }
      .eng{
        margin-top: 20px;
        font-size: 12px;
        font-weight: 600;
        line-height: normal;
        text-transform: uppercase;
        letter-spacing: 0em;
        color: #3D3D3D;
      }
    }
</style>
